import { get, post } from '@/services/API';

export default {
  postAccount: (account) => post('/api/account', { account }),
  getAllAccounts: (params) => get(`/api/account?${new URLSearchParams(params)}`),
};
